import { render, staticRenderFns } from "./BehaviorType.vue?vue&type=template&id=6070a9e7"
import script from "./BehaviorType.vue?vue&type=script&lang=js"
export * from "./BehaviorType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports